// Offline mode in the app (OFFLINE-PLAN.md): the one engine the Supabase client uses (src/lib/supabase.js global fetch),
// IndexedDB in the browser, sync when the device is back online (event), at start and every minute while changes wait.
import { createOffline } from './engine'
import { idbStore, memoryStore } from './store'

let rights = null, getToken = async () => null, currentUid = () => null
const listeners = new Set()
const hasIdb = typeof indexedDB !== 'undefined'
export const offline = createOffline({
  realFetch: (...a) => fetch(...a),
  store: hasIdb ? idbStore() : memoryStore(),
  getRights: () => rights,
  getToken: () => getToken(),
  apikey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  baseUrl: process.env.REACT_APP_SUPABASE_URL || '',   // a queued change goes only to this server (with the login's token)
  onChange: () => listeners.forEach(f => { try { f() } catch (e) {} }),
})
// set by the auth provider: what this login may do ({ can, isCrew, crewName, vesselId }), its token, its user id
export function setOfflineRights(r) { rights = r }
export function setOfflineAuth({ token, uid }) { if (token) getToken = token; if (uid) currentUid = uid }
export function onOfflineChange(fn) { listeners.add(fn); return () => listeners.delete(fn) }
export const syncNow = () => { const uid = currentUid(); return uid ? offline.sync(uid).catch(() => ({ sent: 0 })) : Promise.resolve({ sent: 0 }) }

let started = false
export function startOfflineSync() {
  if (started || typeof window === 'undefined') return
  started = true
  window.addEventListener('online', () => { offline.markUp(); listeners.forEach(f => f()); syncNow() })
  window.addEventListener('offline', () => listeners.forEach(f => f()))
  setInterval(async () => { const uid = currentUid(); if (!uid) return; const s = await offline.status(uid); if (s.waiting.length) syncNow() }, 60000)
  setTimeout(syncNow, 3000)
}
